import { getSiblings } from '../../modules/helpers';

export const ranking = () => {
  const $navLink = document.querySelectorAll('[data-nav]');
  const $tables = document.querySelectorAll('[data-table]');

  if ($navLink.length) {
    $navLink.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        const tab = e.target.getAttribute('data-nav');

        e.target.classList.add('active');

        getSiblings(e.target).map(el => el.classList.remove('active'));

        [...$tables].map(el => (el.id == tab ? el.classList.add('active') : el.classList.remove('active')));
      });
    });
  }
};
